<template>
  <div class="container">
    <div class="columns is-centered">
      <div class="column">
        <h1>Affidavit Form</h1>
        <p>
          You may be eligible for Targeted Financial Assistance (TFA). Payments are made directly to the landlord to cover a tenant's past-due rent and fees plus two months' rent. Please be advised you should continue to pay your rent while your application is being reviewed. To complete your TFA application, please sign the tenant affidavit by typing your name and the date below.
          <br> 
          <br> 
          Click here to view the English version of the affidavit: <a
            :href="$tenantAffidavit"
            target="_blank"
          ><u>tenant affidavit</u></a>
          <br>
          <br>
          Click here to view the Spanish version of the affidavit: <a
            :href="$tenantAffidavitSpanish"
            target="_blank"
          ><u>tenant affidavit (Spanish)</u></a>
        </p>
      </div>
    </div>
    <div>
      <h4 style="text-align: center;"><b><u>Eviction Diversion Targeted Rental Assistance Tenant Agreement and Affidavit</u></b></h4>
      <p>The undersigned <b>{{ TenantName }}</b> ("Tenant") has participated in the City of
          Philadelphia's Eviction Diversion Program (the "EDP") with respect to a residential lease (the
          "Lease") entered into by Tenant, as tenant, and <b>{{ LandlordName }}</b> ("Landlord"), as
          landlord, for premises located at <b>{{ PropertyAddress }}</b>, Philadelphia,
          Pennsylvania (the "Property"). In connection with the EDP, Landlord and Tenant have agreed to,
          among other things, the settlement of past-due rent owed by Tenant to Landlord.
      </p>
      <p>
        In connection with the EDP, the City of Philadelphia has determined to make monetary grants to
        certain landlords participating in the EDP and applied to such past-due rent owed by tenants, in
        amounts established pursuant to the EDP (each such grant, an “EDP Targeted Financial Assistance
        Grant”). The Philadelphia Housing Development Corporation ("PHDC"), as agent for the City,
        oversees the distribution of such EDP Targeted Financial Assistance Grants.
      </p>
      <p>Landlord will be receiving an EDP Targeted Financial Assistance Grant in an amount established, pursuant to the EDP (such amount, the "Funds").</p>
      <p>
        The Funds will be issued by the Public Health Management Corporation ("PHMC") or the Urban Affairs
        Coalition (“UAC”) (each of PHMC and UAC, a "Payment Issuer") on behalf of the City through an
        Automated Clearing House ("ACH") transfer whereby the Grant funds will be direct deposited into
        Landlord's designated bank account.
      </p>
      <p>By electronically signing this form (this "Agreement"), Tenant acknowledges and agrees that the
          issuance of the Funds on Tenant's behalf is subject to the following representations, covenants,
          requirements, terms and obligations:
          <ol>
            <li>The Funds will be applied in full satisfaction of Tenant's obligation to the Landlord for past-due rent. The Funds may not be used for any other purpose.</li>
            <li>The Funds may not be applied toward any cost that has been paid to Tenant or shall be paid on Tenant's behalf by any other funding source, including local, state, and federal assistance programs.</li>
            <li>In the event that Tenant receives any such Funds that may constitute a duplication of benefits (a "DOB") as set forth in Paragraph 2 above, Tenant agrees to immediately notify PHDC, and if PHDC determines in its sole discretion that such funds constitute a DOB, Tenant shall promptly return to the applicable Payment Issuer the portion of such funds that constitute a DOB, in accordance with instructions provided by PHDC to Landlord.</li>
          </ol>
      </p>
      <h3><b><u>DECLARATION UNDER PENALTY OF PERJURY</u></b></h3>
      <p><i>
        I understand that it is a federal offense (18 U.S. Code §1001) and state offense (18 Pa.C.S.A.
        §4904) to knowingly make a false statement in this affidavit. I have read the information carefully to be
        sure that the information contained herein is true and complete before signing. I understand that the
        information provided in this affidavit is subject to verification. I understand that my completion of this
        affidavit or any other document related thereto does not entitle me to receive a benefit from an EDP
        Targeted Financial Assistance Grant
      </i></p>
      <p><i>
        I verify that the tenant information I have stated herein and in connection with my participation in
        the EDP is true, correct, and complete to the best of my knowledge. I further agree to supply such
        additional information as PHDC may require in its sole discretion to verify my identity, including,
        without limitation, the last four digits of my social security number. 
      </i></p>
      <p><i>
        I verify that I am 18 years of age or older; or that I am under 18 years of age and either living separately
        from my parents, married or separated from a spouse, or a parent caring for a child. I understand that if
        I am under 18 and do not meet this definition that I may not sign this document, but that another
        member of the household may be eligible to sign on behalf of the household.
      </i></p>
      <p><i>
        I verify that the monthly rent, and other expenses related to housing (if applicable), that I have stated in connection with my participation in the EDP are true and correct to the best of my knowledge.
      </i></p>
      <p><i>
        I verify that the information I have completed on behalf of other members of the household, if any, is true and correct to the best of my knowledge.
      </i></p>
      <p><i>
        I verify that I am not requesting assistance for any costs that have been paid for, or will be paid for, by any other sources of funds. I understand that this assistance cannot pay for such costs.
      </i></p>
      <p><i>
        I hereby certify that there are <b>{{ NumberOfAdults }}</b> number of adults and <b>{{ NumberOfChildren }}</b> number of children (under the age of 18) living in this house.
      </i></p>
      <p><i>
        I hereby certify that the household income is <b>${{ (Number(Income)/12).toFixed(2) }}</b> per month.
     </i></p>
      <h4><b><i>Affidavit</i></b></h4>
      <p>I certify under penalty of perjury, pursuant to 28 U.S.C. §1746. That the foregoing are true and correct.</p>
      <p><i>
        I give consent/authorization to the City of Philadelphia, the Philadelphia Housing Development
        Corporation (PHDC), the Office of Homeless Services (OHS), the Department of Behavioral Health and
        Intellectual disAbility Services(DBHIDS), and the Philadelphia Housing Authority (PHA) and theirrespective
        agents, employees, and assigns to contact my landlord, and to share, disclose, analyze and discuss all
        medical records and all documentation and information provided in connection with my participation in
        the EDP and in subsequent communications related to the EDP.
      </i></p>
      <p><i>
        I give consent/authorization for PHDC, and its officers, agents, employees, representatives,successors, and
        assigns, to use, share, provide, distribute, disseminate, disclose, make available, receive, analyze, and
        discuss any and all information provided by me or on my behalf in connection with my participation in the
        EDP, whether such information is about me or members of my household, if any, including, but not limited
        to, any and all personally identifiable information (e.g., name(s), home address, date(s) of birth, etc.) and
        contact information (e.g., home telephone number, cell phone number, email address, etc.)with any
        and all entities that may manage, administer, fund, and/or service the EDP, and their respective officers,
        Document version date: 11/3/2023
        agents, employees, representatives, successors, and assigns, including, but not limited to, the City of
        Philadelphia (the "City"), the University of Pennsylvania, the Philadelphia Housing Authority and any entity
        contracted by PHDC to provide optional financial and benefits counseling to EDP participants).
      </i></p>
      <p><b><i>
        By authorizing the designated representative to check the box or by providing my initials below, I
        agree that this serves as my electronic signature, that any electronic signature appearing on this
        Agreement and Affidavit is the same as a handwritten signature for the purposes of validity,
        enforceability, and admissibility, and that a signature provided through electronic means may
        not be denied legal effect solely because itis in electronic form.
      </i></b></p>
      <p><b><i>
        I affix my name hereto and understand that any false or misleading statements or omissions
        may result in criminal and civil actions for fines, penalties, damages, or imprisonment.
      </i></b></p>
    </div>
    <!-- <div>
        <iframe :src="$tenantAffidavit" title="Tenant Affidavit" style="height: 50em; width: 100%;"></iframe>
    </div> -->
    <ValidationObserver
      v-slot="{ errors }"
      tag="div"
    >
      <input-form
        ref="form"
        :errors="errors"
        name="TenantApplicationFrm"
        @submit.prevent="handleSubmit"
      >
        <br>
        <!-- <div class="columns">
          <div class="column">
            <input
              v-model="TFAInfoCheckbox"
              style="margin-right: 8px; vertical-align: middle;"
              true-value="1"
              false-value="0"
              type="checkbox"
            >
            <label>I would like to speak to a City Financial Specialist about Targeted Financial Assistance before signing the affidavit.</label>
          </div>
        </div> -->
        <div
          v-if="TFAInfoCheckbox == true" 
        >
          <callout type="info">
            Click submit and a City Financial Specialist will contact you an answer any questions you may have about the affidavit.
          </callout>
        </div>
        <br>
        <div
          v-if="TFAInfoCheckbox == false"
          class="columns"
        >
          <div class="column">
            <vee-textbox
              v-model="FullName"
              mode="eager"
              name="txt-full-name"
              placeholder="Full Name"
              rules="required"
              required
              error="This field is required"
            />
          </div>
          <div class="column">
            <vee-textbox
              v-model="SignatureDate"
              :name="input-date"
              placeholder="Date"
              type="date"
              rules="required"
              required
              error="This field is required"
            />
          </div>
        </div>
        <callout type="danger">
          After this form is submitted, a City financial specialist will be assigned to your case for review, and you will be provided their contact information.
        </callout>
        <template #submit>
          <div class="actions columns">
            <div class="column is-2 is-offset-10">
              <button
                type="button"
                :disabled="
                  [SubmitStatus.Options.PENDING].includes(SubmitStatus)
                "
                class="button is-primary"
                @click="handleSubmit"
              >
                Submit
              </button>
            </div>
          </div>
          <div class="column">
            <div v-if="SubmitStatus.Value === SubmitStatus.Options.PENDING">
              Submitting...
            </div>
          </div>
        </template>
      </input-form>
    </ValidationObserver>
  </div>
</template>

<script>
import axios from "axios";
import buildTenantAffidavitSubmissionDataObject from "@/utilities/data-objects/tenant-affidavit-data-object";
import buildAffidavitDataFetchObject from "@/utilities/data-objects/get-affidavit-data-object";
import options from "@/utilities/options";
import {
  dataObjectToXml,
  getPropertyValueOrDefault,
} from "@/utilities/functions";

export default {
  name: "AffidavitForm",
  mixins: [options],
  props: {
    applicantId: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      FullName: null,
      SignatureDate: null,
      TFAInfoCheckbox: false,
      TenantName: null,
      LandlordName: null,
      PropertyAddress: null,
      NumberOfAdults: null,
      NumberOfChildren: null,
      Income: null,
    };
  },
  created() {
    var vData = this;
    const dataObject = buildAffidavitDataFetchObject(vData.applicantId, "AFFIDAVIT_PAGE_GET_LANDLORD_DATA"); //CHANGE UDATA NAME FOR CONSISTENCY
    const requestObj = {
      table: process.env.VUE_APP_QB_TENANT,
      data: dataObject,
    };
    // Grab relevant information from QuickBase
    axios //add try catch for finding application id
      .post("https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/V1/EDP-TFA-login-QuickBase-Request-Proxy-Reads", requestObj)
      .then((response) => {
        const responseObject = getPropertyValueOrDefault(["data", "record", "f"], response);
        vData.LandlordName = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "108"));
        vData.TenantName = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "128"));
        var correctedAddress = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "117"));
        var initialAddress = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "8"));
        vData.PropertyAddress = correctedAddress ? correctedAddress : initialAddress;
        vData.NumberOfAdults = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "89"));
        vData.NumberOfChildren = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "90"));
        vData.Income = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "95"));
      });
  },
  methods:{
    async handleSubmit() {
      var vData = this;
      vData.SubmitStatus.Value = vData.SubmitStatus.Options.PENDING;
      const isInputValid = await vData.$refs.form.$parent.validate();
      if (isInputValid) {
        const dataObject = buildTenantAffidavitSubmissionDataObject(vData);
        const xmlDataObject = dataObjectToXml(dataObject);
        const requestObject = {
          table: process.env.VUE_APP_QB_TENANT_AFFIDAVIT,
          action: "API_AddRecord",
          data: xmlDataObject,
        };

        axios
          .post(
            "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/V1/Eviction-Diversion-login-QuickBase-Request-Proxy",
            requestObject,
          )
          .then((qbResult) => {
            console.log(qbResult);
            vData.SubmitStatus.Value = vData.SubmitStatus.Options.OK;
            
            vData.$router.push({
              name: "TenantSuccessPage",
              params: { applicantId: vData.applicantId },
            });
          });
      }
    },
  },
};
</script>